import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { BadgeModule } from 'primeng/badge';
import {
  SupportTicket,
  ticketStatusKey,
  ticketStatusSeverity,
} from '@cosmos/angular/utils';

@Component({
  selector: 'cosmos-ticket-list-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, TranslatePipe, TagModule, BadgeModule],
  templateUrl: './ticket-list-item.component.html',
})
export class TicketListItemComponent {
  readonly ticket = input.required<SupportTicket>();
  readonly open = output<string>();

  protected readonly statusSeverity = computed(() =>
    ticketStatusSeverity(this.ticket().status),
  );

  protected readonly statusKey = computed(() =>
    ticketStatusKey(this.ticket().status),
  );

  protected readonly preview = computed(
    () => this.ticket().last_message?.trim() || null,
  );
}
